import { render } from "./QuestionOneScreen.vue?vue&type=template&id=40208f50&scoped=true&lang=html"
import script from "./QuestionOneScreen.vue?vue&type=script&lang=js"
export * from "./QuestionOneScreen.vue?vue&type=script&lang=js"

import "./QuestionOneScreen.vue?vue&type=style&index=0&id=40208f50&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/sthree_grijper/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40208f50"]])

export default __exports__